import { hasFeature } from "src/generator/hooks/useCopyVal";

export const ADD_VALUES_FEATURE = "addValues";
export const ADD_VALUES_RESULT_FEATURE = "addValuesResult";
export const YESTERDAY_FEATURE = "yesterday";
export const TODAY_FEATURE = "today";
export const DIFFERENCE_FEATURE = "difference";

export const parseNum = (value: unknown): number | null => {
  if (value === null || value === undefined || value === "") return null;
  const parsed = parseFloat(String(value).replace(",", "."));
  return Number.isFinite(parsed) ? parsed : null;
};

/** Value rounded to `decimals`, or null when it already fits. */
export const roundNum = (value: unknown, decimals?: number | string) => {
  const parsed = parseNum(value);
  const places = Number(decimals);
  if (parsed === null || decimals === undefined || decimals === "") return null;
  if (!Number.isInteger(places) || places < 0) return null;
  const rounded = parseFloat(parsed.toFixed(places));
  return rounded === parsed ? null : rounded.toString();
};

// Drops float noise such as 0.1 + 0.2 = 0.30000000000000004
const toCalcString = (value: number) =>
  Number.isFinite(value) ? parseFloat(value.toPrecision(12)).toString() : "";

/** Blank sources count as 0; with every source blank the result is blank too. */
export const sumValues = (values: unknown[]) => {
  const numbers = values
    .map(parseNum)
    .filter((value): value is number => value !== null);
  if (numbers.length === 0) return "";
  return toCalcString(numbers.reduce((acc, value) => acc + value, 0));
};

export const diffValues = (today: unknown, yesterday: unknown) => {
  const todayNum = parseNum(today);
  const yesterdayNum = parseNum(yesterday);
  if (todayNum === null || yesterdayNum === null) return "";
  return toCalcString(todayNum - yesterdayNum);
};

/** Uuids of every cell with the given feature and class, anywhere in the sections tree. */
export const findColIdsByFeatureClass = (
  sections: unknown,
  feature: string,
  className?: string,
): string[] => {
  const ids: string[] = [];
  if (!className) return ids;

  const walk = (node: unknown) => {
    if (!node || typeof node !== "object") return;
    if (Array.isArray(node)) {
      node.forEach(walk);
      return;
    }
    Object.entries(node).forEach(([key, child]: [string, any]) => {
      if (!child || typeof child !== "object") return;
      if (
        !Array.isArray(child) &&
        child.class === className &&
        hasFeature(child.feature, feature)
      ) {
        ids.push(key);
        return;
      }
      walk(child);
    });
  };

  walk(sections);
  return ids;
};
